angular.module('unica_hotel.hotel_services')

.factory('HotelListService', function($http, getBaseApiURL) {

	var hotelListService = {};

	hotelListService.list = function (limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/hotel/list',
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.hotels;
			}

		});

	};

	hotelListService.fullList = function () {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/hotel/full-list',
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.hotels;
			}

		});
	};

	hotelListService.get = function (hotelId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/hotel/detail/' + hotelId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.hotel;
			}

		});

	};

	return hotelListService;

})
;